// ADD new element types at the end of the enum
export enum ElementTypeEnum {
  InlineAnswer,
  SeparateAnswer,
  NominatorAnswer,
  DenominatorAnswer,
  Operator,
  TranslatedString,
  NumberEl,
  Nominator,
  Denominator,
  Image,
  ComparisonAnswer,
  ComparisonItemStart,
  ComparisonItemEnd,
  HighlightedNumber
}
